var map = {
	"./close.svg": "8b1b",
	"./icon-arrow-last.svg": "8e7a",
	"./icon-arrow-next.svg": "b30d",
	"./icon-arrow-right.svg": "2115",
	"./icon-calendar.svg": "35f4",
	"./icon-drop-down.svg": "7c23",
	"./icon-map.svg": "56df",
	"./icon-ranking.svg": "2404",
	"./laptop.svg": "cd06",
	"./minus.svg": "3e24",
	"./plus.svg": "eb38",
	"./search.svg": "d103"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";